import { clr } from '../common/clr'
export const styles = {
    loginBtn: {
        backgroundColor: clr.btnColor
    }
    //   nav: {
    //     backgroundColor: clr.navbarBg
    //   }
}